import { useUser } from '@gik/api/users/user';
import type { BaseUserWithAvatar } from '@gik/core/models/gik/User';
import type { UIComponent } from '@gik/core/types/UI';
import { useBemCN } from '@gik/core/utils/bemBlock';
import type { StreamParticipant } from '@gik/stream/types/StreamParticipant';
import { openUserInfoModal, openUserInfoModalById } from '@gik/user-profile/components/UserInfoModal/UserInfoModal';
import React from 'react';

export type StreamParticipantDisplayProps = {
  participant: StreamParticipant;
  userFullName: string;
  userId: string;
} & UIComponent;

export function StreamParticipantDisplay({
  children,
  className,
  participant,
  userFullName,
  userId,
  ...otherProps
}: React.PropsWithChildren<StreamParticipantDisplayProps>): React.ReactElement {
  const bem = useBemCN('stream-participant-display');

  const { data: user } = useUser(userId);

  return (
    <span
      {...bem(null, null, className)}
      {...otherProps}
      key={`mention-${participant?.id}`}
      className="gik-user-mention"
      onClick={() => {
        if (participant) {
          // TODO: fix typing
          const userInfo: BaseUserWithAvatar = {
            fullName: participant?.display || user?.fullName,
            id: participant?.id,
            avatarThumbSmallURL: participant?.userAvatarThumbSmallURL || user?.avatarThumbSmallURL,
            avatarThumbMediumURL: participant?.userAvatarThumbMediumURL || user?.avatarThumbMediumURL,
            avatarURL: participant?.userAvatarThumbMediumURL || user?.avatarThumbMediumURL,
            emailAddress: null,
          };
          openUserInfoModal(userInfo);
        } else {
          openUserInfoModalById(userId);
        }
      }}
    >
      {userFullName}
    </span>
  );
}
